<template>
  <el-dialog
    class="update-announcement-wrapper"
    title="提示"
    :visible.sync="dialogVisible"
    width="50%"
    top="10vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content">
      <div class="title">问鼎皮肤 {{titleShowVersion}} 版本来啦~！</div>
      <div>
        <p>问鼎皮肤多云平台从临床科研需求出发，汇聚多模态皮科大数据，以患者为中心，影像为主线，将皮肤镜、临床摄影、美容/治疗、手术预约、住院登记等数据有机聚合。</p>
        <p>问鼎皮肤融合先进的AI技术，是一款真正为皮肤科打造的信息化、智能化大数据云平台。</p>
      </div>
      <div class="info-box" v-if="info.length">
        <p>本次更新我们做了如下调整：</p>
        <div v-for="(item, index) in info" :key="index">
          <div class="til"><span style="padding-right: 8px">{{index + 1}}.</span><span>{{item.title}}</span></div>
          <ul class="ul">
            <li v-for="text in item.textList">{{text}}</li>
          </ul>
        </div>
        <img class="pic" src="../assets/loudspeaker.png" alt="" v-if="isShowLoudspeaker">
      </div>
      <div class="title">感谢您对问鼎皮肤云的支持，您的建议是我们宝贵的财富！</div>
    </div>
    <span slot="footer" class="dialog-footer" style="padding-right: 30px">
      <el-button type="primary" @click="understand">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import gql from 'graphql-tag';
  import raceJs from '../race';
  
  export default {
    
    data() {
      return {
        dialogVisible: false, // 直接控制每次更新后是否需要显示更新内容提示，其值来自于 switch
        switch: true, // 控制每次更新后是否需要显示更新内容提示
        isShowLoudspeaker: true, // 是否显示喇叭图片
        meId: -1,
        version: '',
        titleShowVersion: raceJs.version,
        info: [
          // {
          //   title: '拍摄图片',
          //   textList: [
          //     '提升了直接通过皮肤镜镜头拍摄图片的清晰度和尺寸大小',
          //   ],
          // },   
          // v3.0      
          // {
          //   title: '完善了美容/治疗功能',
          //   textList: [
          //     '完善了美容/治疗功能：提高了页面的加载速度',
          //   ],
          // },
          {
            title: '完善了住院信息管理功能',
            textList: [
              '完善了住院信息管理功能，增加了病程、病情、备注等',
            ],
          },
          // {
          //   title: '我的账户',
          //   textList: [
          //     ' 加入报告影像板式的选择（2图一排/3图一排）',
          //     '修复切换模态，打印选择状态消失的bug',
          //     '随访模版样式自适应调整（手机版/pc版）',
          //     '修改了一些bug'
          //   ],
          // },
          // {
          //   title: '数据统计',
          //   textList: [
          //     '修改top10问题',
          //     '优化了页面展示效果',
          //   ],
          // },
          // {
          //   title: '患者管理',
          //   textList: [
          //     '默认根据患者更新时间排序展示',
          //     '优化了页面展示效果',
          //   ],
          // },
          // {
          //   title: '手术预约',
          //   textList: [
          //     '知情同意书2打印内容更新',
          //     '修改了一些bug'
          //   ],
          // },
        ]
      };
    },
    
    methods: {
      // 点击提示对话框“确定”后执行
      understand() {
        this.dialogVisible = false;
        this.modifyDoctorVersion();
      },
      async getVersion() {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              getVersionControl {
                id
                version_num
                version_type
              }
            }`,
            fetchPolicy: "no-cache",
          });
          let data;
          for (const item of res.data.getVersionControl) {
            if (item.version_type === 'pc') {
              data = item;
            }
          }
          if (data) {
            return data.version_num;
          }
        } catch (error) {
          console.log(error);
        }
      },
      async getDoctorVersion() {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              me{
                id
                mark_version
              }
            }`,
            fetchPolicy: "no-cache",
          });
          this.meId = res.data.me.id;
          return res.data.me.mark_version;
        } catch (error) {
          console.log(error);
        }
      },
      async modifyDoctorVersion() {
        try {
          await this.$apollo.mutate({
            mutation: gql`mutation(
              $id: Int!
              $mark_version: String
            ){
              modifyDoctor(
                id: $id
                mark_version: $mark_version
              )
            }`,
            variables: {
              id: this.meId,
              mark_version: this.version,
            }
          });
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
        window.location.reload();
      },
    },
    
    async mounted() {
      // 判断是否需要提示
      const version = await this.getVersion();
      const doctorVersion = await this.getDoctorVersion();
      //console.log("In UpdateAnnouncement, version and doctorVersion:",version,doctorVersion)
      if (version !== undefined && doctorVersion !== undefined) {
        if (version !== doctorVersion) {
          // reload page
          //window.location.reload();
          // display New Version Announcement
          this.dialogVisible = this.switch;
          // Will be updated to doctor table
          this.version = version;
        }
      }
      //console.log("In UpdateAnnouncement, dialogVisible:",this.dialogVisible)
    }
  
  }
</script>

<style>
  /*dialog样式修改*/
  .update-announcement-wrapper .el-dialog__header .el-dialog__title{
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .update-announcement-wrapper .el-dialog__header{
    padding: 20px 24px 10px;
  }
  .update-announcement-wrapper .el-dialog__body {
    padding: 0 20px;
  }
</style>
<style lang="less" scoped>
  .update-announcement-wrapper{
    .content{
      border-top: 2px solid #4da3c0;
      padding: 0 4px;
      color: #333;
      font-size: 16px;
      line-height: 20px;
      .title{
        color: #111;
        padding: 30px 0;
        font-size: 24px;
        font-weight: bold;
        line-height: 30px;
      }
      .info-box{
        position: relative;
        padding-top: 20px;
        .pic{
          position: absolute;
          right: 0;
          bottom: 0;
          width: 226px;
          transform: rotateY(180deg);
        }
      }
      .ul{
        padding-left: 28px;
        list-style: inside;
      }
    }
  }
</style>
